import * as S from './styles';

type ProductLabelTheme = 'primary' | 'secondary';

const withAlpha = (hexColor: string, alpha: number): string => {
    const normalizedHex = (hexColor || '').replace('#', '');
    const safeAlpha = Math.max(0, Math.min(1, alpha));
    const alphaHex = Math.round(safeAlpha * 255).toString(16).padStart(2, '0').toUpperCase();

    if (normalizedHex.length === 3) {
        const [r, g, b] = normalizedHex.split('');
        return `#${r}${r}${g}${g}${b}${b}${alphaHex}`;
    }

    if (normalizedHex.length === 6) {
        return `#${normalizedHex}${alphaHex}`;
    }

    return '#2666CF1A';
}

declare type ProductLabelProps = {
    title?: string;
    theme?: ProductLabelTheme;
    primaryColor: string;
    secondaryColor: string;
}

export default function ProductLabel({
    title,
    theme = 'primary',
    primaryColor,
    secondaryColor,
}: ProductLabelProps) {
    const isPrimary = theme === 'primary';
    const textColor = isPrimary ? primaryColor : secondaryColor;
    const backgroundColor = withAlpha(textColor, 0.15);

    return (
        <S.Container $backgroundColor={backgroundColor}>
            <S.Title $textColor={textColor}>{title}</S.Title>
        </S.Container>
    )
}
